import { externalShipmentWithLabelValidate } from '../../application/dtos/external_shipment_with_label_validate'

export class ExternalShipmentWithLabelEntity {
    constructor({client_id, channel_sale, unique_order_number, total_price, consignee, products, kits, boxes}){
        this.client_id = client_id;
        this.channel_sale = channel_sale;
        this.unique_order_number = unique_order_number;
        this.total_price = total_price;
        this.consignee = consignee;
        this.products = products;
        this.kits = kits;
        this.boxes = boxes;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return externalShipmentWithLabelValidate(this);
    }
}